module.exports = __webpack_public_path__ + "assets/flags/lu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lu.svg
// module id = 506
// module chunks = 0